export const ColumnItem = Symbol('Column');
//# sourceMappingURL=dndItemTypes.js.map